import React, { useState, useContext } from 'react';
import { Link } from 'react-router-dom'; 
import { registerUser, loginUser } from '../utils/apiServices';
import { AuthContext } from '../contexts/AuthContext';
import thankYouImage from '../img/grow-you-business.png';
import '../stylesheets/login.css';

function AuthForm() {
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [fullName, setFullName] = useState('');
  const [password, setPassword] = useState('');
  const [isRegister, setIsRegister] = useState(false);
  const [errors, setErrors] = useState({});
  const { user, login, loading } = useContext(AuthContext);

  const handleUsernameChange = (event) => setUsername(event.target.value);
  const handleEmailChange = (event) => setEmail(event.target.value);
  const handleFullNameChange = (event) => setFullName(event.target.value);
  const handlePasswordChange = (event) => setPassword(event.target.value);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (isRegister) {
      handleRegister();
    } else {
      handleLogin();
    }
  };

  const handleLogin = async () => {
    try {
      const data = await loginUser(username, password);
      await login(data.access);
      setErrors({});
    } catch (error) {
      console.error('Error login:', error);
      setErrors({ detail: error.response?.data?.detail || 'Error al iniciar sesión' });
    }
  };

  const handleRegister = async () => {
    try {
      await registerUser(username, email, fullName, password);
      handleLogin();
    } catch (error) {
      console.error('Error registro:', error);
      let errorMessage = 'Error al registrar usuario';
      if (error.response?.data?.detail) {
        errorMessage = error.response.data.detail;
      }
      setErrors({ detail: errorMessage });
    }
  };

  if (loading) return <div>Cargando...</div>;

  // --- PANTALLA DE BIENVENIDA MEJORADA ---
  if (user) {
    return (
      <section className="thank_you">
        <div className='thank_you__image'>
          <img src={thankYouImage} alt="Thank You" onError={(e) => e.target.style.display='none'} />
        </div>
        <div className="thank_you__text">
          {/* Texto reducido y directo */}
          <h1 style={{marginBottom: '10px'}}>¡Hola, {user?.full_name || 'Usuario'}!</h1>
          <h3 style={{fontWeight: 'normal', marginBottom: '30px', color: '#666'}}>
            Bienvenido a tu panel de gestión empresarial. ¿Qué deseas hacer hoy?
          </h3>
          
          {/* NUEVOS BOTONES GRANDES */}
          <div className='thank_you__actions'>
            <Link to='/conexiones' className='thank_you__button thank_you__button--primary'>
              🚀 Ir a mis Conexiones
            </Link>
            
            <Link to='/empresa' className='thank_you__button'>
              🏢 Editar Perfil de Empresa
            </Link>

            <Link to='/' className='thank_you__button'>
              🏠 Volver al Inicio
            </Link>
          </div>
        </div>
      </section>
    );
  }

  // --- FORMULARIO DE LOGIN/REGISTRO ---
  return (
    <div className="lineabase">
      <div className="auth-container">
        <div className="auth-column auth-info">
          <h2>{isRegister ? 'Crea tu Cuenta' : 'Bienvenido de Nuevo'}</h2>
          <p>{isRegister ? 'Únete a nuestra red.' : 'Accede a tu cuenta.'}</p>
        </div>

        <div className="auth-column auth-form">
          <div className="document-check">
            <form onSubmit={handleSubmit} className="document-check-form">
              <label htmlFor="username" className="form-label">Usuario</label>
              <input className="form-input" type="text" id="username" value={username} onChange={handleUsernameChange} required />
              
              {isRegister && (
                <>
                  <label htmlFor="email" className="form-label">Email</label>
                  <input className="form-input" type="email" id="email" value={email} onChange={handleEmailChange} required />
                  <label htmlFor="fullName" className="form-label">Nombre Completo</label>
                  <input className="form-input" type="text" id="fullName" value={fullName} onChange={handleFullNameChange} required />
                </>
              )}

              <label htmlFor="password" className="form-label">Contraseña</label>
              <input className="form-input" type="password" id="password" value={password} onChange={handlePasswordChange} required />

              {errors.detail && <p className="error-message">{errors.detail}</p>}

              <button type="submit" className="form-submit-button">
                {isRegister ? 'Registrar' : 'Entrar'}
              </button>

              <button type="button" onClick={() => setIsRegister(!isRegister)} className="form-toggle-button">
                {isRegister ? '¿Ya tienes cuenta? Entra' : '¿No tienes cuenta? Regístrate'}
              </button>
              
              {!isRegister && <Link to="/forgot-password" className="forgot-password-link">¿Olvidaste contraseña?</Link>}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AuthForm;